export const LIVE_REPORT_TIMEZONE = 'Asia/Kolkata';

// datetime-local has no timezone. Always display and submit Kolkata wall time.
export const toLiveReportDateInput = (date) => {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: LIVE_REPORT_TIMEZONE,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(date);
  const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
  return `${values.year}-${values.month}-${values.day}T${values.hour}:${values.minute}`;
};

export const toLiveReportTimestamp = (value) => `${value}:00+05:30`;
